import { flexRender, Cell } from '@tanstack/react-table';
import { CSSProperties } from 'react';

import { ColumnMeta } from '../table-v2';
import { getStickyStyles } from '../utils';

interface CellContentsProps<T> {
  cell: Cell<T, unknown>;
  classNames?: string;
}

export const CellContents = <T,>(props: CellContentsProps<T>) => {
  const { cell, classNames } = props;

  let styles: CSSProperties = {};

  if (cell.column.getIsPinned()) {
    styles = getStickyStyles(cell.column);
  }

  let classes = classNames ?? '';

  if ((cell.column.columnDef.meta as ColumnMeta | undefined)?.classes) {
    classes += ' ' + (cell.column.columnDef.meta as ColumnMeta | undefined)?.classes + ' ';
  }

  return (
    <td style={styles} className={`${classes ?? ''} body-td`}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};
